import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Differentials } from "@/components/site/Differentials";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Specialties } from "@/components/site/Specialties";
import { Physiotherapy } from "@/components/site/Physiotherapy";
import { Pilates } from "@/components/site/Pilates";
import { WhenToSeek } from "@/components/site/WhenToSeek";
import { Team } from "@/components/site/Team";
import { Attendants } from "@/components/site/Attendants";
import { Articles } from "@/components/site/Articles";
import { Convenios } from "@/components/site/Convenios";
import { Reviews } from "@/components/site/Reviews";
import { SchedulingCTA } from "@/components/site/SchedulingCTA";
import { Location } from "@/components/site/Location";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { RafaChat } from "@/components/site/RafaChat";
import { AudioGreeting } from "@/components/site/AudioGreeting";
import { Preloader } from "@/components/site/Preloader";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <Differentials />
        <Marquee />
        <About />
        <Specialties />
        <Physiotherapy />
        <Pilates />
        <WhenToSeek />
        <Team />
        <Attendants />
        <Articles />
        <Convenios />
        <Reviews />
        <SchedulingCTA />
        <Location />
        <Contact />
      </main>
      <Footer />
      <RafaChat />
      <AudioGreeting />
    </div>
  );
}
